var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    fill: "#EBEFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    stroke: "#E3EFF5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Add Button"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_15556_1332",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H34C37.3137 0 40 2.68629 40 6V34C40 37.3137 37.3137 40 34 40H6C2.68629 40 0 37.3137 0 34V6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H34C37.3137 0 40 2.68629 40 6V34C40 37.3137 37.3137 40 34 40H6C2.68629 40 0 37.3137 0 34V6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1.43056H34V-1.43056H6V1.43056ZM38.5694 6V34H41.4306V6H38.5694ZM34 38.5694H6V41.4306H34V38.5694ZM1.43056 34V6H-1.43056V34H1.43056ZM6 38.5694C3.47637 38.5694 1.43056 36.5236 1.43056 34H-1.43056C-1.43056 38.1038 1.89621 41.4306 6 41.4306V38.5694ZM38.5694 34C38.5694 36.5236 36.5236 38.5694 34 38.5694V41.4306C38.1038 41.4306 41.4306 38.1038 41.4306 34H38.5694ZM34 1.43056C36.5236 1.43056 38.5694 3.47637 38.5694 6H41.4306C41.4306 1.89621 38.1038 -1.43056 34 -1.43056V1.43056ZM6 -1.43056C1.89621 -1.43056 -1.43056 1.89621 -1.43056 6H1.43056C1.43056 3.47637 3.47637 1.43056 6 1.43056V-1.43056Z",
    fill: "#E3EFF5",
    mask: "url(#path-2-inside-1_15556_1332)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4653 19.4746L12.2169 21.2261L19.1611 14.2944V29.4126H21.6456V14.2944L28.5774 21.2386L30.3414 19.4746L20.4034 9.53654L10.4653 19.4746Z",
    fill: "#666666"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/IconUpload.d2f0bc8ec53c26028c57b593ea7dd2cb.svg";
export { ForwardRef as ReactComponent };